import React, { useEffect, useRef, useState } from "react";
import { ArrowUpRight, Music2, Play } from "lucide-react";

// Latest public posts verified on 2026-09-26. Update this list for new uploads.
// Automatic discovery requires a connected TikTok Display API account.
export const recentTikToks = [
  { id: "7689644012176690484", title: "NRG Ethan Lotus Fade Eye for C-Mound" },
  { id: "7621679612417854738", title: "Skye one-way flash for Showers on Bind" },
  { id: "7602753188613131538", title: "Brimstone molly to stop CT floods" },
];

function TikTokPlayer({ video }) {
  const frame = useRef(null);
  const [status, setStatus] = useState("idle");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    setStatus("idle");
    function onMessage(event) {
      if (event.origin !== "https://www.tiktok.com" || event.source !== frame.current?.contentWindow || event.data?.["x-tiktok-player"] !== true) return;
      if (event.data.type === "onPlayerReady" || event.data.type === "onStateChange") {
        setStatus("ready");
      } else if (event.data.type === "onPlayerError" || event.data.type === "onError") {
        // An autoplay restriction is not a broken video: native Play still works.
        setStatus(event.data.value?.errorCode === 3002 ? "manual" : "unavailable");
      }
    }
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [attempt]);

  return <>
    <div className="socials-video-player">
      <iframe
        key={attempt}
        ref={frame}
        title={`TikTok video: ${video.title}`}
        loading="lazy"
        src={`https://www.tiktok.com/player/v1/${video.id}?controls=1&description=1&rel=0&autoplay=0`}
        allow="fullscreen; encrypted-media; picture-in-picture"
        referrerPolicy="no-referrer"
        allowFullScreen
        onError={() => setStatus("unavailable")}
      />
    </div>
    {status === "manual" && <p className="socials-embed-status" role="status">Press Play in the video to start watching.</p>}
    {status === "unavailable" && <p className="socials-embed-status" role="status">TikTok reported a playback problem. Reload the player or open this video on TikTok.</p>}
    <div className="socials-player-help"><span>Video not loading?</span><button type="button" onClick={() => setAttempt((value) => value + 1)}>Reload player</button></div>
  </>;
}

export default function RecentTikToks() {
  const [selected, setSelected] = useState(0);
  const video = recentTikToks[selected];
  return (
    <section className="socials-recent" aria-labelledby="socials-recent-title">
      <div className="socials-section-heading"><div><span className="socials-eyebrow">FROM THE FEED</span><h2 id="socials-recent-title">Fresh from TikTok</h2></div><Music2 aria-hidden="true" /></div>
      <div className="socials-video-choices" role="group" aria-label="Choose a TikTok video">
        {recentTikToks.map((post, index) => <button type="button" key={post.id} aria-pressed={index === selected} onClick={() => setSelected(index)}><Play size={16} aria-hidden="true" /><span>{post.title}</span></button>)}
      </div>
      <p className="socials-embed-status">Press Play to watch. Videos load from TikTok, which may use cookies and collect usage data.</p>
      <TikTokPlayer key={video.id} video={video} />
      <a className="socials-text-link" href={`https://www.tiktok.com/@valovate_val/video/${video.id}`} target="_blank" rel="noopener noreferrer">Watch this video on TikTok <ArrowUpRight size={16} aria-hidden="true" /></a>
    </section>
  );
}
